import React, { useEffect, useState } from "react";
import { Icon, Image, ProgressBar } from "@nubeteck/components";
import { SmallCardsGroup } from "../../custom/cards";
import { ProgramSVG } from "../../../assets";
// import { useAppSelector } from "src/core";
import { FormatterUtils } from "@nubeteck/utils";
import { useLocale } from "../../../i18n/localeContext";
import { getUserEnrollementPage } from "../../../Api/content";
import { Skeleton } from "antd";
import { StrapiError } from "../../../pages/StrapiError";

interface IUserProgram {
  programaNombre: string;
  porcentajeProgreso: number;
  periodo: string;
  materiasSeleccionadas: number;
  totalFacturaMaterias: number;
  monedaSimbolo: string;
}

const UserProgramCards = ({
  userInfo,
  setSelectedSubjectsVisible,
  isLoading,
}: {
  userInfo: IUserProgram;
  setSelectedSubjectsVisible: () => void;
  isLoading: boolean;
}) => {
  const { locale } = useLocale();
  const [userEnrollementPage, setUserEnrollementPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setUserEnrollementPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getUserEnrollementPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setUserEnrollementPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setUserEnrollementPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setUserEnrollementPage(null);
      }}
    />;
  }

  const userData = [
    {
      title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (userEnrollementPage?.couse_selection?.program_nb || "Programa"),
      icon: <Image src={ProgramSVG} alt="ícono de programa" width={45} preview={false} />,
      information: isLoading ? "...cargando" : userInfo?.programaNombre ?? "Sin datos",
    },
    {
      title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (userEnrollementPage?.couse_selection?.advance_nb || "Avance"),
      information: isLoading ? (
        "...cargando"
      ) : (
        <ProgressBar percent={userInfo?.porcentajeProgreso} size="small" />
      ),
    },
    {
      title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (userEnrollementPage?.couse_selection?.subject_selected_nb || "Cant. seleccionadas"),
      icon: <Icon name="" color="#EBEBEB" />,
      information: isLoading ? (
        "...cargando"
      ) : userInfo?.materiasSeleccionadas !== undefined ? (
        <span>
          <span
            style={{
              fontSize: "11.5px",
              whiteSpace: "nowrap",
              position: "relative",
              top: "-3px",
              left: "-5px",
              color: "gray",
              cursor: "pointer",
            }}
          >
            {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (userEnrollementPage?.couse_selection?.show_subject || "Ver materias")}
          </span>
          {userInfo?.materiasSeleccionadas?.toString()}
        </span>
      ) : (
        "Sin datos"
      ),
      onClick: setSelectedSubjectsVisible,
    },
    {
      title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (userEnrollementPage?.couse_selection?.total_nb || "Total"),
      icon: <Icon name="" color="#EBEBEB" />,
      information: `${
        userInfo?.totalFacturaMaterias !== undefined
          ? `${userInfo?.monedaSimbolo}  ${FormatterUtils.number(
              userInfo?.totalFacturaMaterias?.toFixed(2),
            )}`
          : isLoading
          ? "...cargando"
          : "Sin datos"
      }`,
    },
    {
      title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (userEnrollementPage?.couse_selection?.period_nb || "Periodo"),
      icon: <Icon name="" color="#EBEBEB" />,
      information: isLoading ? "...cargando" : userInfo?.periodo ?? "Sin datos",
    },
  ];

  return <SmallCardsGroup cards={userData} />;
};

export default UserProgramCards;
